import React from 'react';
import { TouchableOpacity, View } from 'react-native';
import { Ionicons } from '@expo/vector-icons';

import { STATUS } from '../../../../common/constants';
import { getFullMachineName } from '../../../../common/utils/machine';
import { Label, Text } from '../../../components';
import { useThemedStyles } from '../../../hooks/useThemedStyles';
import { useTheme } from '../../../theme';

/**
 * Ordered stop rows for the run overview step and the on-the-run list.
 * Tapping a row opens the stop details; the current stop is highlighted.
 */
const StopsList = ({
	sortedDockets,
	currentDocketId,
	isDocketDone,
	onOpenStopDetails,
	onSelectStop,
}) => {
	const styles = useThemedStyles(createStyles);
	const { theme } = useTheme();

	return (
		<View>
			{
				(sortedDockets || []).map((docket, index) => {
					const machineName = getFullMachineName(docket.machine, docket.machine?.place, docket.machine?.location);
					const isComplete = isDocketDone
						? isDocketDone(docket)
						: docket.status === STATUS.COMPLETE;
					const isCurrent = !isComplete && docket.id === currentDocketId;
					const onPress = onSelectStop || onOpenStopDetails;
					const isInProgress = !isComplete && Boolean(docket.startedProcessing);

					return (
						<TouchableOpacity
							key={docket.id}
							style={[styles.row, isCurrent && styles.rowCurrent]}
							activeOpacity={0.86}
							onPress={onPress ? () => onPress(docket) : undefined}
							disabled={!onPress}
						>
							<Text style={styles.rowIndex}>{index + 1}</Text>
							<View style={styles.rowTextWrap}>
								<Text style={styles.rowName}>{machineName || `Stop ${index + 1}`}</Text>
							</View>
							{
								isComplete && (
									<Label label="Done" green={true} style={styles.rowLabel} />
								)
							}
							{
								isCurrent && (
									<Label label="Selected" primary={true} style={styles.rowLabel} />
								)
							}
							{
								isInProgress && !isCurrent && (
									<Label label="In progress" yellow={true} style={styles.rowLabel} />
								)
							}
							{
								Boolean(onPress) && (
									<Ionicons name="chevron-forward" size={16} color={theme.text2} />
								)
							}
						</TouchableOpacity>
					);
				})
			}
		</View>
	);
};

const createStyles = (theme) => ({
	row: {
		flexDirection: 'row',
		alignItems: 'center',
		backgroundColor: theme.mainBg3,
		borderRadius: 8,
		paddingVertical: 8,
		paddingHorizontal: 10,
		marginBottom: 6,
	},
	rowCurrent: {
		borderWidth: 1,
		borderColor: theme.text1,
	},
	rowIndex: {
		width: 22,
		fontSize: 12,
		fontWeight: '700',
		color: theme.text2,
	},
	rowTextWrap: {
		flex: 1,
		paddingRight: 8,
	},
	rowName: {
		fontSize: 13,
		fontWeight: '600',
		color: theme.text1,
	},
	rowLabel: {
		marginBottom: 0,
		marginRight: 6,
	},
});

export default StopsList;
